/**
 * occupationApi.js
 * -----------
 * API client for Occupation Master using createMasterApiClient.
 * Connects directly to FastAPI backend /occupation/ endpoints.
 * Exports are processed asynchronously via JobEngine background jobs (useExportJob).
 */
import { createMasterApiClient } from '../../common/masterApiFactory';

export const occupationClient = createMasterApiClient('occupation');

export async function listOccupations(params = {}) {
  return await occupationClient.list(params);
}

export async function getOccupationDetail(occupationId) {
  return await occupationClient.getById(occupationId);
}

export async function createOccupation(payload) {
  return await occupationClient.create(payload);
}

export async function updateOccupation(occupationId, payload) {
  return await occupationClient.update(occupationId, payload);
}

export async function archiveOccupation(occupationId) {
  return await occupationClient.archive(occupationId);
}

export async function deleteOccupation(occupationId) {
  return await occupationClient.remove(occupationId);
}

export async function getOccupationOptions() {
  return await occupationClient.getDropdownOptions();
}
